import {
  Component,
  OnInit,
  ViewEncapsulation
}                                  from '@angular/core';
import { Router }                  from '@angular/router';

import { ScreenSizeService }       from '../../../core/services/screen-size.service';
import { EventsService }           from '../../../core/services/events.service';
import { SCREEN_SIZE_WAS_CHANGED } from '../../../app.constants';

@Component({
  selector: 'search',
  templateUrl: './search.component.html',
  styleUrls: ['./search.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SearchComponent implements OnInit {
  isVisible: boolean = true;
  isFocused: boolean = false;
  searchPhrase: string = '';

  constructor (
    private screenSize: ScreenSizeService,
    private eventsBus: EventsService,
    private router: Router
  ) {}

  ngOnInit () {
    this.checkVisibility();
    this.eventsBus
      .on(SCREEN_SIZE_WAS_CHANGED)
      .subscribe(() => {
        this.checkVisibility();
      });
  }

  checkVisibility () {
    if (!this.screenSize.isSmall()) {
      return this.isVisible = true;
    }

    this.isVisible = this.isFocused;
  }

  showSearchField () {
    if (this.searchPhrase) {
      return this.search();
    }

    this.isFocused = true;
    this.checkVisibility();
  }

  hideSearchField () {
    setTimeout(() => {
      this.isFocused = false;
      this.checkVisibility();
    }, 100);
  }

  search () {
    this.hideSearchField();
    const text = this.searchPhrase;

    if (text.trim()) {
      this.searchPhrase = '';
      this.router.navigate(['/search'], { queryParams: { text, src: text}});
    }
  }
}


// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/(IGH Projects)/jobs/EVFS PROD_FRONTEND granima.de/workspace/frontend/src/app/moddules/header/search/search.component.ts